import { Configuration, PopupRequest } from '@azure/msal-browser';

// Configuração do MSAL para Microsoft Entra ID
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '2f1f46f3-7810-4f67-8c04-14262417475d',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'b3f53731-1770-4d28-a431-680489b41598'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage', // Usar localStorage para persistir entre sessões
    storeAuthStateInCookie: false, // Desabilitado para SPAs
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            break;
          case 1: // LogLevel.Warning
            console.warn(message);
            break;
          case 2: // LogLevel.Info
            console.info(message);
            break;
          case 3: // LogLevel.Verbose
            console.debug(message);
            break;
        }
      },
    },
  },
};

// Configuração de permissões necessárias
export const loginRequest: PopupRequest = {
  scopes: [
    'User.Read',
    'User.ReadBasic.All',
    'Group.Read.All',
  ],
  prompt: 'select_account',
};

// Configuração para obter token silencioso
export const silentRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'Group.Read.All'],
  account: null, // Será definido dinamicamente
};

// Domínios autorizados
export const AUTHORIZED_DOMAINS = [
  '@cidadania4u.com.br',
  '@becivis.com'
];

// Grupos do Azure AD - Configure os IDs reais dos grupos no .env
export const AZURE_GROUPS = {
  MASTER: import.meta.env.VITE_AZURE_GROUP_MASTER || 'master-group-id',
  ADMIN: import.meta.env.VITE_AZURE_GROUP_ADMIN || 'admin-group-id', 
  USER: import.meta.env.VITE_AZURE_GROUP_USER || 'user-group-id',
};
